import type { RouteObject } from 'react-router-dom'

import { Component } from '@/modules/employerAdvisors/pages/employerAdvisors'
import { EmployerAdvisorsRoutePathsEnum } from '@/modules/employerAdvisors/routes/employerAdvisorsRouteConfig.types'

export const EMPLOYER_ADVISORS_ROUTES: RouteObject[] = [
  {
    element: <Component />,
    path: EmployerAdvisorsRoutePathsEnum.ADVISORS,
  },
]
